module.exports = __webpack_public_path__ + "static/UoB-logo.3f08c8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/WinterLanding/UoB-logo.png
// module id = 466
// module chunks = 35783957827783